'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useCustomAddressStore, useStore } from '@libs/common-next';
import type { DeliveryMethodType } from '@libs/common-types';
import { fetchMiniPdpProductTailored } from '../api';
const ONE_MINUTE = 60 * 1000;
export const MINI_PDP_TAILORED_QUERY_KEY = 'mini-pdp-product-tailored';
type UseQueryMiniPdpTailoredProps = {
  variantSkus: string[];
  deliveryMethodsList?: DeliveryMethodType[];
};
export const useQueryMiniPdpTailored = t0 => {
  const $ = _c(23);
  const {
    deliveryMethodsList,
    variantSkus
  } = t0;
  const {
    selectedStoreId
  } = useStore();
  const sddAddress = useCustomAddressStore(_temp);
  const hasAddressStateHydrated = useCustomAddressStore(_temp2);
  let t1;
  if ($[0] !== deliveryMethodsList) {
    t1 = deliveryMethodsList || [];
    $[0] = deliveryMethodsList;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== sddAddress || $[3] !== selectedStoreId || $[4] !== t1 || $[5] !== variantSkus) {
    t2 = [MINI_PDP_TAILORED_QUERY_KEY, selectedStoreId, ...t1, variantSkus, sddAddress].filter(Boolean);
    $[2] = sddAddress;
    $[3] = selectedStoreId;
    $[4] = t1;
    $[5] = variantSkus;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const queryKey = t2;
  let t3;
  if ($[7] !== deliveryMethodsList || $[8] !== sddAddress || $[9] !== selectedStoreId || $[10] !== variantSkus) {
    t3 = () => {
      if (!deliveryMethodsList) {
        return;
      }
      return fetchMiniPdpProductTailored({
        deliveryMethodsList,
        storeId: selectedStoreId,
        customAddress: sddAddress ?? undefined,
        variantSkus
      });
    };
    $[7] = deliveryMethodsList;
    $[8] = sddAddress;
    $[9] = selectedStoreId;
    $[10] = variantSkus;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = hasAddressStateHydrated && Boolean(deliveryMethodsList?.length);
  let t5;
  if ($[12] !== queryKey || $[13] !== t3 || $[14] !== t4) {
    t5 = {
      queryKey,
      queryFn: t3,
      enabled: t4,
      staleTime: ONE_MINUTE,
      retry: false
    };
    $[12] = queryKey;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const {
    data,
    isLoading,
    isPending,
    isFetching,
    isError,
    error
  } = useQuery(t5);
  const t6 = isLoading || !hasAddressStateHydrated;
  let t7;
  if ($[16] !== data || $[17] !== error || $[18] !== isError || $[19] !== isFetching || $[20] !== isPending || $[21] !== t6) {
    t7 = {
      data,
      isLoading: t6,
      isPending,
      isFetching,
      isError,
      error
    };
    $[16] = data;
    $[17] = error;
    $[18] = isError;
    $[19] = isFetching;
    $[20] = isPending;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
function _temp(state) {
  return state.address;
}
function _temp2(state_0) {
  return state_0._hasHydrated;
}